import { ENTRY_POINT } from "../../global-config";
import { getToken, ValidateToken } from "../Auth/Authentification";

export async function getMediaPreps(id_prep){
    const options = {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + getToken()
        }
      };
      
      
    let data = await fetch(ENTRY_POINT+"/media_preps/?order%5Bid%5D=ASC&page=1&itemsPerPage=999&id_prep="+id_prep, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error(error);
        });
    
    if(ValidateToken(data) || data !== undefined){
        return data;
    }else{
        return "error";
    }
}

export async function deleteMediaPreps(id_mediaprep){
    const options = {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + getToken()
        }
      };
      
      
    let data = await fetch(ENTRY_POINT+id_mediaprep, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error(error);
        });
    
    if(ValidateToken(data) || data !== undefined){
        return data;
    }else{
        return "error";
    }
}

export async function postMediaPreps(fd){
    const options = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        body: fd
      };
      
      
    let data = await fetch(ENTRY_POINT+"/media_preps", options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error(error);
        });
    
    if(ValidateToken(data) || data !== undefined){
        return data;
    }else{
        return "error";
    }
}